import { render, staticRenderFns } from "./Lgx296721465535889408.vue?vue&type=template&id=6e45a6bc&scoped=true&"
import script from "./Lgx296721465535889408.vue?vue&type=script&lang=js&"
export * from "./Lgx296721465535889408.vue?vue&type=script&lang=js&"
import style0 from "./Lgx296721465535889408.vue?vue&type=style&index=0&id=6e45a6bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e45a6bc",
  null
  
)

export default component.exports